var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUltima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 13,
    viewBox: "0 0 95 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89223 0.410156V7.90947C9.89223 8.70749 9.71519 9.42888 9.3611 10.0736C9.01229 10.7131 8.48116 11.2205 7.76769 11.5957C7.05951 11.9709 6.16636 12.1585 5.08824 12.1585C3.55561 12.1585 2.38764 11.7675 1.58433 10.9853C0.78102 10.2031 0.379366 9.16728 0.379366 7.87776V0.410156H2.82893V7.50517C2.82893 8.46174 3.02447 9.13293 3.41556 9.51873C3.80664 9.90453 4.38534 10.0974 5.15165 10.0974C5.69072 10.0974 6.12672 10.0049 6.45967 9.81997C6.79791 9.635 7.0463 9.34961 7.20485 8.96381C7.3634 8.57801 7.44267 8.08651 7.44267 7.48932V0.410156H9.89223ZM19.2244 12V0.410156H21.6818V9.97059H26.3828V12H19.2244ZM39.3694 12H36.9119V2.45542H33.7648V0.410156H42.5166V2.45542H39.3694V12ZM50.7944 12V0.410156H53.2519V12H50.7944ZM67.5703 12L64.7799 2.90728H64.7085C64.7191 3.12397 64.735 3.45163 64.7561 3.89028C64.7825 4.32364 64.8063 4.78608 64.8275 5.27757C64.8486 5.76907 64.8592 6.21301 64.8592 6.60937V12H62.6633V0.410156H66.0086L68.7515 9.27298H68.7991L71.7084 0.410156H75.0538V12H72.7628V6.51425C72.7628 6.14959 72.7681 5.72943 72.7786 5.25379C72.7945 4.77815 72.813 4.32629 72.8341 3.89821C72.8553 3.46484 72.8711 3.13982 72.8817 2.92314H72.8103L69.8217 12H67.5703ZM91.5681 12L90.7278 9.24127H86.5025L85.6622 12H83.0145L87.105 0.362592H90.1095L94.2159 12H91.5681ZM90.1412 7.18015L89.3009 4.48483C89.2481 4.30515 89.1767 4.07525 89.0869 3.79515C89.0023 3.50977 88.9151 3.22174 88.8253 2.93107C88.7407 2.63511 88.672 2.37879 88.6191 2.16211C88.5663 2.37879 88.4923 2.64832 88.3972 2.9707C88.3073 3.2878 88.2201 3.58904 88.1356 3.87443C88.051 4.15981 87.9902 4.36328 87.9532 4.48483L87.1209 7.18015H90.1412Z",
    fill: "url(#paint0_linear_1876_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1876_11",
    x1: 140,
    y1: 12,
    x2: -24.5745,
    y2: 30.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482422,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltima);
export default __webpack_public_path__ + "static/media/ultima.7367a9d6fbcb6db6c62a6ea317562b83.svg";
export { ForwardRef as ReactComponent };